import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';

import OnboardingTutorial from '@pkg/components/OnboardingTutorial/OnboardingTutorial';
import { useMediaQuery } from '@pkg/providers';

import { ONBOARDING_PROFILE_CREATE_CLASS } from '../styles';

const ONBOARD_PROFILE_CREATE_CACHE_KEY = 'profile-create-onboarding';

export const ProfileOnboarding = () => {
    const { t: translate } = useTranslation('onboarding');
    const { tablet } = useMediaQuery();

    const [isProfileCreateShown, setIsProfileCreateShown] = useLocalStorage(ONBOARD_PROFILE_CREATE_CACHE_KEY);
    const [showProfileCreateOnboarding, setShowProfileCreateOnboarding] = useState(false);
    const onCloseProfileCreateOnboarding = () => {
        setShowProfileCreateOnboarding(false);
        const el = document.querySelector(`.${ONBOARDING_PROFILE_CREATE_CLASS}`);
        if (el) {
            const hoverEvent = new MouseEvent('mouseover', {
                view: window,
                bubbles: true,
                cancelable: true,
            });
            el.dispatchEvent(hoverEvent);
        }
    };

    useEffect(() => {
        if (isProfileCreateShown) return;
        const handler = () => {
            setIsProfileCreateShown(true);
            setShowProfileCreateOnboarding(true);
        };
        const timeout = setTimeout(handler, 2000);
        return () => clearTimeout(timeout);
    }, [isProfileCreateShown, setIsProfileCreateShown]);

    if (tablet && showProfileCreateOnboarding)
        return (
            <OnboardingTutorial
                highlightElement={ONBOARDING_PROFILE_CREATE_CLASS}
                onClose={onCloseProfileCreateOnboarding}
                size="small"
                slides={[
                    {
                        content: translate('profile-create__description'),
                        button: translate('profile-create__button'),
                    },
                ]}
            />
        );
    return null;
};
